import { useEffect, useState } from 'react';

import { useLocalStorage } from 'common/hooks';
import { useIsMobile } from 'common/hooks/useIsMobile';

export const useSidebar = () => {
  const isMobile = useIsMobile();
  const [isSidebarOpenStored, setIsSidebarOpenStored] = useLocalStorage('sidebar-open', 'true');
  const [isSidebarOpen, setIsSidebarOpen] = useState(isSidebarOpenStored === 'true');

  useEffect(() => {
    const isSidebarOpenStored = isMobile ? false : isSidebarOpen;
    setIsSidebarOpenStored(isSidebarOpenStored.toString());
  }, [isSidebarOpen, setIsSidebarOpenStored, isMobile]);

  return { isSidebarOpen, setIsSidebarOpen };
};
